<section class="h-100">

  <kl-capture-image-form-control [s3Category]="dialogData?.data.s3Category" (capturedImage)="onImageCaptured($event)"></kl-capture-image-form-control>
</section>
